import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Heading, Button, Icon, Text } from '../index';
import styles from './HeroBanner.module.scss';
import cx from 'classnames';
import { HERO_PRIMARY, HERO_TYPES, LINK_TYPES } from '../../lib/constants';
import useInterval from '../../lib/services/useInterval';
import { getIconUrl } from '../../lib/helpers/mediaHeplers';

const HERO_ANIMATION_INTERVAL = 3300;

const HeroBanner = (props) => {
    const {
        buttonContextIconUrl,
        buttonContextText,
        designType,
        primaryCtaAltText,
        primaryCtaLinkText,
        primaryCtaLinkType,
        primaryCtaLinkUrl,
        secondaryCtaAltText,
        secondaryCtaLinkText,
        secondaryCtaLinkType,
        secondaryCtaLinkUrl,
        items,
        title,
        subtitle,
        decorationImage,
        fileReference,
        altText,
        targetId,
        antiflickerItems = [],
        showLockIcon = false,
    } = props;

    const containerRef = useRef();
    const primaryContainerRef = useRef();
    const [currentCardIndex, setCurrentCardIndex] = useState(0);
    const [isPlaying] = useState(true);
    const [reset, setReset] = useState(true); //Helps to force render when there's only 1 card to maintain the primary type animation

    const cards = (items || []).map(({ whiteText, orangeText }) => ({
        title: whiteText,
        subtitle: orangeText,
    }));

    useInterval(
        () => {
            setCurrentCardIndex((currentCardIndex + 1) % cards.length);
            if (isPrimaryType) {
                setReset(!reset);
            }
            // setReset(!reset);
        },
        HERO_ANIMATION_INTERVAL,
        isPlaying
    );
    const isPrimaryType = designType === HERO_PRIMARY;
    const TitleTag = isPrimaryType ? 'h2' : 'h1';

    useEffect(() => {
        if (isPrimaryType) {
            const cardElements = primaryContainerRef.current.getElementsByClassName(styles.heading);
            let maxHeight = 0;

            for (let i = 0; i < cardElements.length; i++) {
                const height = cardElements[i].clientHeight;
                if (height > maxHeight) {
                    maxHeight = height;
                }
            }

            primaryContainerRef.current.style.height = `${maxHeight}px`;
        }
        console.log('isPrimaryType', isPrimaryType);
    }, [isPrimaryType, reset]);

    // HeroBanerList NEED TO BE ADDED AS ADOBE TARGET ID ON DIALOG TO BE ABLE TO SHOW THE COMPONENT LIST OPTION

    const headingElements = cards.map((card, index) => (
        <Heading
            headingLevel="h1"
            color="white"
            className={cx(styles.heading, {
                [styles.hidden]: currentCardIndex !== index,
            })}
            key={`${index}${reset}`}
        >
            <span className={styles['first-line']}>{cards[index].title}</span>
            <span className={styles['second-line']}>{cards[index].subtitle}</span>
        </Heading>
    ));

    console.log(props);

    const features = [
        {
            id: 'feature-1',
            text: 'No annual fee',
        },
        {
            id: 'feature-2',
            text: 'Flexible payment options',
        },
        {
            id: 'feature-3',
            text: '24/7 customer support',
        },
    ];

    if (targetId === 'HeroBannerImage-test') {
        return (
            <section
                className={cx(
                    'hero',
                    styles.root,
                    styles[designType],
                    {
                        [styles.seasonal]: decorationImage,
                    },
                    targetId ? 'atexperiments' : null,
                    styles.HeroBannerImageContainer
                )}
                id="hero"
            >
                {decorationImage ? (
                    <div
                        className={cx(styles['seasonal-decorations'], {
                            atexperiments: antiflickerItems.includes('decorations'),
                        })}
                        style={{ backgroundImage: `url('${decorationImage}')` }}
                    />
                ) : null}
                <div className={cx(styles.container, styles.HeroBannerImageText)}>
                    <div
                        className={cx(
                            styles['text-container'],
                            styles.HeroBannerImageTextContainer
                        )}
                        ref={containerRef}
                    >
                        {isPrimaryType ? (
                            <div
                                className={cx(styles['primary-container'], {
                                    atexperiments: antiflickerItems.includes('slides'),
                                })}
                                ref={primaryContainerRef}
                            >
                                {headingElements}
                            </div>
                        ) : null}
                        <TitleTag
                            className={cx(styles.title, {
                                atexperiments: antiflickerItems.includes('title'),
                            })}
                        >
                            {title}
                        </TitleTag>
                        {!isPrimaryType && subtitle ? (
                            <p
                                className={cx(styles.subtitle, {
                                    atexperiments: antiflickerItems.includes('subTitle'),
                                })}
                            >
                                {subtitle}
                            </p>
                        ) : null}
                        <div className={cx(styles.buttons, styles.HeroBannerImageButton)}>
                            {primaryCtaLinkText && primaryCtaLinkType && primaryCtaLinkUrl ? (
                                <Button
                                    altText={primaryCtaAltText || undefined}
                                    buttonStyle="hero-primary"
                                    className={cx(styles['primary-cta'], {
                                        atexperiments: antiflickerItems.includes('primaryCTA'),
                                    })}
                                    linkText={primaryCtaLinkText}
                                    linkType={primaryCtaLinkType}
                                    linkUrl={primaryCtaLinkUrl}
                                    targetId={targetId}
                                />
                            ) : null}
                            {secondaryCtaLinkText &&
                            secondaryCtaLinkType &&
                            secondaryCtaLinkUrl &&
                            designType === HERO_PRIMARY ? (
                                <Button
                                    altText={secondaryCtaAltText || undefined}
                                    className={cx({
                                        atexperiments: antiflickerItems.includes('secondaryCTA'),
                                    })}
                                    buttonStyle="hero-secondary"
                                    linkText={secondaryCtaLinkText}
                                    linkType={secondaryCtaLinkType}
                                    linkUrl={secondaryCtaLinkUrl}
                                    targetId={targetId}
                                />
                            ) : null}
                        </div>
                        {designType === HERO_PRIMARY && buttonContextText ? (
                            <aside className={cx(styles['button-context'])}>
                                {buttonContextIconUrl ? (
                                    <Icon
                                        className={cx(styles['button-context-icon'], {
                                            atexperiments:
                                                antiflickerItems.includes('buttonContext'),
                                        })}
                                        size="x-small"
                                        url={getIconUrl(buttonContextIconUrl)}
                                    />
                                ) : null}
                                <p className={cx(styles['button-context-text'])}>
                                    {buttonContextText}
                                </p>
                            </aside>
                        ) : null}
                        {targetId === 'description-test' ? (
                            <Text
                                className={styles['button-description']}
                                content="text to be replaced"
                                size="small"
                            />
                        ) : null}
                    </div>
                    <div className={cx(styles.HeroBannerImage)}>
                        <img
                            src={fileReference}
                            alt={altText}
                            className={cx({
                                atexperiments: antiflickerItems.includes('image'),
                            })}
                        />
                    </div>
                </div>
            </section>
        );
    }

    if (targetId === 'HeroBanerList') {
        return (
            <section
                className={cx(
                    'hero',
                    styles.root,
                    styles[designType],
                    {
                        [styles.seasonal]: decorationImage,
                    },
                    targetId ? 'atexperiments' : null,
                    styles.HeroBannerImageContainer
                    // styles.HeroBannerListContainer
                )}
                id="hero"
            >
                {decorationImage ? (
                    <div
                        className={cx(styles['seasonal-decorations'], {
                            atexperiments: antiflickerItems.includes('decorations'),
                        })}
                        style={{ backgroundImage: `url('${decorationImage}')` }}
                    />
                ) : null}
                <div className={cx(styles.container, styles.HeroBannerImageText)}>
                    <div
                        className={cx(
                            styles['text-container'],
                            styles.HeroBannerImageTextContainer
                        )}
                        ref={containerRef}
                    >
                        {isPrimaryType ? (
                            <div
                                className={cx(styles['primary-container'], {
                                    atexperiments: antiflickerItems.includes('slides'),
                                })}
                                ref={primaryContainerRef}
                            >
                                {headingElements}
                            </div>
                        ) : null}
                        <TitleTag
                            className={cx(styles.title, {
                                atexperiments: antiflickerItems.includes('title'),
                            })}
                        >
                            {title}
                        </TitleTag>
                        {!isPrimaryType && subtitle ? (
                            <p
                                className={cx(styles.subtitle, {
                                    atexperiments: antiflickerItems.includes('subTitle'),
                                })}
                            >
                                {subtitle}
                            </p>
                        ) : null}
                        <ul className={cx(styles.list)}>
                            {features.map((item) => (
                                <li key={item.id} className={styles.item}>
                                    <div className={styles.iconWrapper}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 1000 1000"
                                            aria-hidden="true"
                                            focusable="false"
                                        >
                                            <g>
                                                <path
                                                    className="cls-2"
                                                    d="M500,950.39c-248.35,0-450.39-202.05-450.39-450.39S251.65,49.61,500,49.61s450.39,202.05,450.39,450.39-202.05,450.39-450.39,450.39Z"
                                                    style={{ fill: 'white' }}
                                                />
                                                <path
                                                    className="cls-1"
                                                    d="M500,80.67c231.22,0,419.33,188.11,419.33,419.33s-188.11,419.33-419.33,419.33S80.67,731.22,80.67,500,268.78,80.67,500,80.67M500,18.55C234.53,18.55,18.55,234.53,18.55,500s215.98,481.45,481.45,481.45,481.45-215.98,481.45-481.45S765.47,18.55,500,18.55h0Z"
                                                    style={{ fill: '#3f2a56' }}
                                                />
                                            </g>
                                            <path
                                                className="cls-3"
                                                d="M500,168.69c182.99,0,331.31,148.32,331.31,331.31s-148.32,331.31-331.31,331.31-331.31-148.32-331.31-331.31S317.01,168.69,500,168.69Z"
                                                style={{
                                                    fill: '#7d6d96',
                                                    stroke: '#7d6d96',
                                                    strokeMiterlimit: 10,
                                                    strokeWidth: 1.09,
                                                }}
                                            />
                                            <path
                                                className="cls-4"
                                                d="M500,168.69c182.99,0,331.31,148.32,331.31,331.31s-148.32,331.31-331.31,331.31-331.31-148.32-331.31-331.31S317.01,168.69,500,168.69Z"
                                                style={{
                                                    fill: 'none',
                                                    stroke: '#7d6d96',
                                                    strokeLinecap: 'round',
                                                    strokeLinejoin: 'round',
                                                    strokeWidth: 62.12,
                                                }}
                                            />
                                            <g>
                                                <rect
                                                    className="cls-1"
                                                    x="318.83"
                                                    y="430.14"
                                                    width="122.2"
                                                    height="310.21"
                                                    rx="61.1"
                                                    ry="61.1"
                                                    transform="translate(-288.6 385.45) rotate(-40.37)"
                                                    style={{ fill: '#fff' }}
                                                />
                                                <rect
                                                    className="cls-1"
                                                    x="499.66"
                                                    y="282.66"
                                                    width="122.2"
                                                    height="477.61"
                                                    rx="61.1"
                                                    ry="61.1"
                                                    transform="translate(650.22 1281.98) rotate(-139.63)"
                                                    style={{ fill: '#fff' }}
                                                />
                                            </g>
                                        </svg>
                                    </div>
                                    <span className={styles.text}>{item.text}</span>
                                </li>
                            ))}
                        </ul>
                        <div className={cx(styles.buttons, styles.HeroBannerImageButton)}>
                            {primaryCtaLinkText && primaryCtaLinkType && primaryCtaLinkUrl ? (
                                <Button
                                    altText={primaryCtaAltText || undefined}
                                    buttonStyle="hero-primary"
                                    className={cx(styles['primary-cta'], {
                                        atexperiments: antiflickerItems.includes('primaryCTA'),
                                    })}
                                    linkText={primaryCtaLinkText}
                                    linkType={primaryCtaLinkType}
                                    linkUrl={primaryCtaLinkUrl}
                                    targetId={targetId}
                                />
                            ) : null}
                            {secondaryCtaLinkText &&
                            secondaryCtaLinkType &&
                            secondaryCtaLinkUrl &&
                            designType === HERO_PRIMARY ? (
                                <Button
                                    altText={secondaryCtaAltText || undefined}
                                    className={cx({
                                        atexperiments: antiflickerItems.includes('secondaryCTA'),
                                    })}
                                    buttonStyle="hero-secondary"
                                    linkText={secondaryCtaLinkText}
                                    linkType={secondaryCtaLinkType}
                                    linkUrl={secondaryCtaLinkUrl}
                                    targetId={targetId}
                                />
                            ) : null}
                        </div>
                        {designType === HERO_PRIMARY && buttonContextText ? (
                            <aside className={cx(styles['button-context'])}>
                                {buttonContextIconUrl ? (
                                    <Icon
                                        className={cx(styles['button-context-icon'], {
                                            atexperiments:
                                                antiflickerItems.includes('buttonContext'),
                                        })}
                                        size="x-small"
                                        url={getIconUrl(buttonContextIconUrl)}
                                    />
                                ) : null}
                                <p className={cx(styles['button-context-text'])}>
                                    {buttonContextText}
                                </p>
                            </aside>
                        ) : null}
                        {targetId === 'description-test' ? (
                            <Text
                                className={styles['button-description']}
                                content="text to be replaced"
                                size="small"
                            />
                        ) : null}
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section
            className={cx(
                'hero',
                styles.root,
                styles[designType],
                {
                    [styles.seasonal]: decorationImage,
                },
                targetId ? 'atexperiments' : null
            )}
            id="hero"
        >
            {decorationImage ? (
                <div
                    className={cx(styles['seasonal-decorations'], {
                        atexperiments: antiflickerItems.includes('decorations'),
                    })}
                    style={{ backgroundImage: `url('${decorationImage}')` }}
                />
            ) : null}
            <div className={styles.container}>
                <div className={cx(styles['text-container'])} ref={containerRef}>
                    {isPrimaryType ? (
                        <div
                            className={cx(styles['primary-container'], {
                                atexperiments: antiflickerItems.includes('slides'),
                            })}
                            ref={primaryContainerRef}
                        >
                            {headingElements}
                        </div>
                    ) : null}
                    <TitleTag
                        className={cx(styles.title, {
                            atexperiments: antiflickerItems.includes('title'),
                        })}
                    >
                        {title}
                    </TitleTag>
                    {!isPrimaryType && subtitle ? (
                        <p
                            className={cx(styles.subtitle, {
                                atexperiments: antiflickerItems.includes('subTitle'),
                            })}
                        >
                            {subtitle}
                        </p>
                    ) : null}
                    <div className={cx(styles.buttons)}>
                        {primaryCtaLinkText && primaryCtaLinkType && primaryCtaLinkUrl ? (
                            <Button
                                altText={primaryCtaAltText || undefined}
                                buttonStyle="hero-primary"
                                className={cx(styles['primary-cta'], {
                                    atexperiments: antiflickerItems.includes('primaryCTA'),
                                })}
                                linkText={primaryCtaLinkText}
                                linkType={primaryCtaLinkType}
                                linkUrl={primaryCtaLinkUrl}
                                targetId={targetId}
                                lockIcon={showLockIcon ? true : false}
                            />
                        ) : null}
                        {secondaryCtaLinkText &&
                        secondaryCtaLinkType &&
                        secondaryCtaLinkUrl &&
                        designType === HERO_PRIMARY ? (
                            <Button
                                altText={secondaryCtaAltText || undefined}
                                className={cx({
                                    atexperiments: antiflickerItems.includes('secondaryCTA'),
                                })}
                                buttonStyle="hero-secondary"
                                linkText={secondaryCtaLinkText}
                                linkType={secondaryCtaLinkType}
                                linkUrl={secondaryCtaLinkUrl}
                                targetId={targetId}
                            />
                        ) : null}
                    </div>
                    {designType === HERO_PRIMARY && buttonContextText ? (
                        <aside className={cx(styles['button-context'])}>
                            {buttonContextIconUrl ? (
                                <Icon
                                    className={cx(styles['button-context-icon'], {
                                        atexperiments: antiflickerItems.includes('buttonContext'),
                                    })}
                                    size="x-small"
                                    url={getIconUrl(buttonContextIconUrl)}
                                />
                            ) : null}
                            <p className={cx(styles['button-context-text'])}>{buttonContextText}</p>
                        </aside>
                    ) : null}
                    {targetId === 'description-test' ? (
                        <Text
                            className={styles['button-description']}
                            content="text to be replaced"
                            size="small"
                        />
                    ) : null}
                </div>
                {!!fileReference && (
                    <img
                        src={fileReference}
                        alt={altText}
                        className={cx(styles.image, {
                            atexperiments: antiflickerItems.includes('image'),
                        })}
                    />
                )}
            </div>
        </section>
    );
};

HeroBanner.displayName = 'HeroBanner';

HeroBanner.propTypes = {
    buttonContextIconUrl: PropTypes.string,
    buttonContextText: PropTypes.string,
    designType: PropTypes.oneOf(HERO_TYPES).isRequired,
    primaryCtaAltText: PropTypes.string,
    primaryCtaLinkText: PropTypes.string,
    primaryCtaLinkType: PropTypes.oneOf(LINK_TYPES),
    primaryCtaLinkUrl: PropTypes.string,
    secondaryCtaAltText: PropTypes.string,
    secondaryCtaLinkText: PropTypes.string,
    secondaryCtaLinkType: PropTypes.oneOf(LINK_TYPES),
    secondaryCtaLinkUrl: PropTypes.string,
    subtitle: PropTypes.string,
    title: PropTypes.string.isRequired,
    decorationImage: PropTypes.string,
    fileReference: PropTypes.string,
    altText: PropTypes.string,
    targetId: PropTypes.string,
    antiflickerItems: PropTypes.arrayOf(PropTypes.string),
};

export default HeroBanner;
